/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://atmwdkrbdjel5o6dbywbnto5zy.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:8dff0a64-2265-4d5f-9e20-7c8918441752",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_8qFgXwsaC",
    "aws_user_pools_web_client_id": "3je7m06tbp4q78lq3mpgdtobf0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "supervisor3a6bf2fe6f704919adbed532349a5e4a122152-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
